import React, { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import {
  confirmEmail,
  confirmPinCode,
  updatePassword,
} from "../../DAL/Login/Login";
import EmailForm from "./components/EmailForm";
import PinCodeForm from "./components/PinCodeForm";
import NewPasswordForm from "./components/NewPasswordForm";
import { get_app_logo } from "src/config/config";
import GrAuthLayout from "src/design-system/components/GrAuthLayout";
import {
  AUTH_BRAND_DESCRIPTION,
  AUTH_BRAND_HEADING,
  AUTH_BRAND_HIGHLIGHTS,
  AUTH_BRAND_MARK,
  AUTH_BRAND_MARK_NAME,
  AUTH_BRAND_MARK_SUFFIX,
} from "../authBrand";
import { copyrightLine } from "../Login";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import GrButton from "src/design-system/components/GrButton";

// Title and line under it for each step (0 email, 1 PIN code, 2 new password).
const STEP_TEXT = [
  { title: "Forgot Password", subtitle: "Enter your Email." },
  { title: "Please check your email", subtitle: "Enter PIN Code here." },
  { title: "Reset Password", subtitle: "Enter your New Password." },
];

export default function ForgetPassword() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { projectInfo } = useContentSetting();
  const [status, setStatus] = useState(0);
  const [adminEmail, setAdminEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmitEmail = async (_email) => {
    setAdminEmail(_email);
    const formData = new FormData();
    formData.append("email", _email);
    const result = await confirmEmail(formData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
      setStatus(1);
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitPinCode = async (pinCode) => {
    const formData = new FormData();
    formData.append("email", adminEmail);
    formData.append("verification_code", pinCode);
    const result = await confirmPinCode(formData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
      setStatus(2);
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitNewPassword = async (newPassword, confirmPassword) => {
    const formData = new FormData();
    formData.append("email", adminEmail);
    formData.append("password", newPassword);
    formData.append("confirm_password", confirmPassword);
    const result = await updatePassword(formData);
    if (result.code === 200) {
      setStatus(0);
      navigate("/login");
      enqueueSnackbar("Password Changed Successfully", { variant: "success" });
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  return (
    <GrAuthLayout
      brandMark={AUTH_BRAND_MARK}
      brandMarkName={AUTH_BRAND_MARK_NAME}
      brandMarkSuffix={AUTH_BRAND_MARK_SUFFIX}
      heading={AUTH_BRAND_HEADING}
      description={AUTH_BRAND_DESCRIPTION}
      highlights={AUTH_BRAND_HIGHLIGHTS}
      appStrip
      formLogo={get_app_logo()}
      legal={copyrightLine(projectInfo?.brand_name)}
      title={STEP_TEXT[status].title}
      subtitle={STEP_TEXT[status].subtitle}
      footer={
        <>
          Back to Login?
          <GrButton variant="link" size="lg" component={RouterLink} to="/login">
            Login
          </GrButton>
        </>
      }
    >
      {status === 0 ? (
        <EmailForm
          onhandleEmailSubmit={handleSubmitEmail}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      ) : null}
      {status === 1 ? (
        <PinCodeForm
          onhandlePinCodeSubmit={handleSubmitPinCode}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      ) : null}
      {status === 2 ? (
        <NewPasswordForm
          onhandleNewPasswordSubmit={handleSubmitNewPassword}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      ) : null}
    </GrAuthLayout>
  );
}
